import React, { useEffect, useMemo, useState } from "react";
import ConfirmWithPhrasePopup from "../Common/ConfirmWithPhrasePopup";
import "../../css/Popups/BulkMailPopup.css";
import { useToast } from "../../Contexts/ToastContext";
import { systemEmailsAPI } from "../../api/apiClient";

const BulkMailPopup = ({ onClose, registrations }) => {
  const [selected, setSelected] = useState([]);
  const [mailType, setMailType] = useState("change"); 
  const [showConfirm, setShowConfirm] = useState(false);
  const {showToast} = useToast();
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    setSelected([]);
  }, [mailType]);

  const sortedRegistrations = useMemo(() => {
    return [...registrations].sort((a, b) =>
      (a.primaryParticipantName || "").localeCompare(
        b.primaryParticipantName || "",
        "pl"
      )
    );
  }, [registrations]);

  const filteredRegistrations = useMemo(() => {
    if (mailType === "payment") {
      return sortedRegistrations.filter(
        (r) => parseFloat(r.displayedBalance || 0) < 0
      );
    }
    return sortedRegistrations.filter(
    (r) => r.status !== 5
  );
  }, [sortedRegistrations, mailType]);

  const toggleRegistration = (guid) => {
    setSelected((prev) =>
      prev.includes(guid)
        ? prev.filter((g) => g !== guid)
        : [...prev, guid]
    );
  };

  const toggleAll = () => {
    const visibleGuids = filteredRegistrations.map((r) => r.guid);
    const allVisibleSelected = visibleGuids.every((g) =>
      selected.includes(g)
    );

    if (allVisibleSelected) {
      setSelected((prev) =>
        prev.filter((g) => !visibleGuids.includes(g))
      );
    } else {
      setSelected((prev) => [...new Set([...prev, ...visibleGuids])]);
    }
  };

  const selectedInView = filteredRegistrations.filter((r) =>
    selected.includes(r.guid)
  );

  const canSend = selectedInView.length > 0 && !!mailType;

  const handleConfirmSend = async () => {
  try {
    setIsSending(true);
    setShowConfirm(false);
    showToast("Wysyłanie wiadomości...", "processing");

    await systemEmailsAPI.sendBulk({
      mailType,
      reservationGuids: selectedInView.map((r) => r.guid),
    });

    showToast(`Wysłano ${selectedInView.length} wiadomości.`,"success");
    onClose();
  } catch (err) {
    console.error(err);
    showToast("Nie udało się wysłać wiadomości.", "error");
  } finally {
    setIsSending(false);
    setShowConfirm(false);
  }
};


  return (
    <div className="bm-popup-overlay">
      <div className="bm-popup-content">
        <div className="bm-title">Wysyłka wiadomości e-mail</div>

        <div className="bm-toggle-wrapper">
          <div className="bm-toggle">
            <div
              className={`bm-toggle-option ${
                mailType === "change" ? "active" : ""
              }`}
              onClick={() => setMailType("change")}
            >
              Mail o rezerwacji
            </div>
            <div
              className={`bm-toggle-option ${
                mailType === "payment" ? "active" : ""
              }`}
              onClick={() => setMailType("payment")}
            >
              Mail o dopłacie
            </div>
          </div>
        </div>

        <div className="bm-list-header">
          <div className="bm-select-all" onClick={toggleAll}>
            {filteredRegistrations.length > 0 &&
            selectedInView.length === filteredRegistrations.length
              ? "Odznacz wszystkie"
              : "Zaznacz wszystkie"}
          </div>
          <span>
            Zaznaczono: {selectedInView.length} /{" "}
            {filteredRegistrations.length}
          </span>
        </div>

        <div className="bm-registrations-list">
          {filteredRegistrations.map((r) => {
            const isSelected = selected.includes(r.guid);
            const statusClass = `status-${r.status}`;
            const balance = parseFloat(r.displayedBalance || 0);
            const saldoClass =
              balance > 0
                ? "saldo-positive"
                : balance < 0
                ? "saldo-negative"
                : "saldo-zero";

            return (
              <div
                key={r.guid}
                className={`registration-entry ${isSelected ? "selected" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleRegistration(r.guid);
                }}
              >
                <div className="registration-line">
                  <span className={`reg-code ${statusClass}`}>
                    {r.reservationCode || "(brak)"}
                  </span>
                  <div className="registration-line-content">
                    <span className="reg-main-name">
                      {r.primaryParticipantName}
                    </span>
                    <span className={`reg-saldo ${saldoClass}`}>
                      {balance.toFixed(2)} zł
                    </span>
                    <span className="reg-count">
                      ({r.participantsCount}x👤)
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="bm-actions-fixed">
          <div
            className={`bm-cancel ${isSending ? "disabled" : ""}`}
            onClick={() => !isSending && onClose()}
          >
            Anuluj
          </div>

          <div
            className={`bm-send ${!canSend || isSending ? "disabled" : ""}`}
            onClick={() => canSend && !isSending && setShowConfirm(true)}
          >
            {isSending ? (
              <>
                <i className="fa fa-spinner fa-spin" style={{ marginRight: "6px" }}></i>
                Wysyłanie...
              </>
            ) : (
              "Wyślij"
            )}
          </div>
        </div>


        {showConfirm && (
          <ConfirmWithPhrasePopup
            phrase="okoń"
            text={`Czy na pewno chcesz wysłać ${
              mailType === "payment"
                ? "informacje o dopłacie"
                : "informacje o zmianie"
            } dla ${selectedInView.length} rezerwacji?`}
            onConfirm={handleConfirmSend}
            onCancel={() => setShowConfirm(false)}
          />
        )}
      </div>
    </div>
  );
};

export default BulkMailPopup;
